import { createGlobalState } from 'react-use';

const useLiveWindModalStationIsOfflineState = createGlobalState(false);

export const useLiveWindModalStationIsOffline = () => useLiveWindModalStationIsOfflineState();

const useLiveWindModalStationIsDataLaggingState = createGlobalState(true);

export const useLiveWindModalStationIsDataLagging = () =>
  useLiveWindModalStationIsDataLaggingState();
